import { Card, Checkbox, Col, Divider, Row, Typography } from "antd";
import React, { useState } from "react";
import TermsModal from "./TermsModal";
import DepositOtp from "./DepositOtp";

const { Title, Text } = Typography;

const DepositSummary = () => {
  return (
    <div className="card">
      <h3>Deposit Summary</h3>
      <Divider />
      <Row gutter={30}>
        <Col span={8}>
          <Text strong>Total Receivable Amount:</Text>
          <Text> $12,000</Text>
        </Col>
        <Col span={8}>
          <Text strong>Total Earnings:</Text>
          <Text> $2,000</Text>
        </Col>
        <Col span={8}>
          <Text strong>Interest Rate:</Text>
          <Text> $500</Text>
        </Col>
      </Row>
      <Row gutter={30} style={{ marginTop: 10 }}>
        <Col span={8}>
          <Text strong>Deposit Amount:</Text>
          <Text> $10,000</Text>
        </Col>
        <Col span={8}>
          <Text strong>Effective Yield:</Text>
          <Text> 8.65%</Text>
        </Col>
        <Col span={8}>
          <Text strong>Tenure:</Text>
          <Text> 18 months</Text>
        </Col>
      </Row>
      <Divider />
      <Row gutter={30} style={{ marginTop: 10 }}>
        <Col span={8}>
          <Text strong>Maturity Date:</Text>
          <Text> 26 March 2026</Text>
        </Col>
        <Col span={8}>
          <Text strong>Interest:</Text>
          <Text> Pay Interest</Text>
        </Col>
        <Col span={8}>
          <Text strong>Interest Payout:</Text>
          <Text> Auto Transfer</Text>
        </Col>
      </Row>
      <Row gutter={30} style={{ marginTop: 10 }}>
        <Col span={8}>
          <Text strong>Principal:</Text>
          <Text> KOLA</Text>
        </Col>
        <Col span={8}>
          <Text strong>Nominee Middle Name:</Text>
          <Text> NAGA MANI</Text>
        </Col>
        <Col span={8}>
          <Text strong>Nominee Last Name:</Text>
          <Text> -</Text>
        </Col>
      </Row>
      <Row gutter={30} style={{ marginTop: 10 }}>
        <Col span={8}>
          <Text strong>Deposit Type:</Text>
          <Text> Regular FD</Text>
        </Col>
        <Col span={8}>
          <Text strong>Joint FD:</Text>
          <Text> No</Text>
        </Col>
        <Col span={8}>
          <Text strong>Booking Date:</Text>
          <Text> 21 March 2024</Text>
        </Col>
      </Row>
    </div>
  );
};
const PersonalInformation = () => {
  return (
    <div className="card">
      <h3>Your Personal Information</h3>
      <Divider />
      <Row gutter={16}>
        <Col span={8}>
          <Text strong>First Name:</Text>
          <Text> JEEVAN</Text>
        </Col>
        <Col span={8}>
          <Text strong>Middle Name:</Text>
          <Text> KUMAR</Text>
        </Col>
        <Col span={8}>
          <Text strong>Last Name:</Text>
          <Text> KOLA</Text>
        </Col>
      </Row>

      <Row gutter={16} style={{ marginTop: 10 }}>
        <Col span={8}>
          <Text strong>PAN:</Text>
          <Text> AFZPK7190K</Text>
        </Col>
        <Col span={8}>
          <Text strong>Gender:</Text>
          <Text> MALE</Text>
        </Col>
        <Col span={8}>
          <Text strong>Date of Birth:</Text>
          <Text> 08/08/1992</Text>
        </Col>
      </Row>
      <Divider />

      <Row gutter={16} style={{ marginTop: 10 }}>
        <Col span={24}>
          <Text strong>Email:</Text>
          <Text> Chandrasekhar123@Gmail.com</Text>
        </Col>
      </Row>

      <Row gutter={16} style={{ marginTop: 10 }}>
        <Col span={24}>
          <Text strong>Address:</Text>
          <Text>
            {" "}
            Jeevan Building, Street 4, Kakaityaa Hills, Hitech city, Hyderabad,
            Telengana - 500044
          </Text>
        </Col>
      </Row>
      <Divider />

      <Row gutter={16} style={{ marginTop: 10 }}>
        <Col span={8}>
          <Text strong>Occupation:</Text>
          <Text> Service - Private Sector</Text>
        </Col>
        <Col span={8}>
          <Text strong>Marital Status:</Text>
          <Text> Married</Text>
        </Col>
        <Col span={8}>
          <Text strong>Date of Birth (Father):</Text>
          <Text> 08/08/1992</Text>
        </Col>
      </Row>

      <Row gutter={16} style={{ marginTop: 10 }}>
        <Col span={8}>
          <Text strong>Father First Name:</Text>
          <Text> KOLA</Text>
        </Col>
        <Col span={8}>
          <Text strong>Father Middle Name:</Text>
          <Text> SHIVA</Text>
        </Col>
        <Col span={8}>
          <Text strong>Father Last Name:</Text>
          <Text> NARAYANA</Text>
        </Col>
      </Row>
    </div>
  );
};

const NomineeDetails = () => {
  return (
    <div className="card">
      <h3>Nominee Detials</h3>
      <Divider />
      <Row gutter={30}>
        <Col span={8}>
          <Text strong>Nominee First Name:</Text>
          <Text> KOLA</Text>
        </Col>
        <Col span={8}>
          <Text strong>Nominee Middle Name:</Text>
          <Text> NAGA MANI</Text>
        </Col>
        <Col span={8}>
          <Text strong>Nominee Last Name:</Text>
          <Text> -</Text>
        </Col>
      </Row>

      <Row gutter={30} style={{ marginTop: 10 }}>
        <Col span={8}>
          <Text strong>Gender:</Text>
          <Text> FEMALE</Text>
        </Col>
        <Col span={8}>
          <Text strong>Relation to Applicant:</Text>
          <Text> SPOUSE</Text>
        </Col>
        <Col span={8}>
          <Text strong>Date of Birth:</Text>
          <Text> 08/08/1992</Text>
        </Col>
      </Row>
      <Divider />
      <Row gutter={30} style={{ marginTop: 10 }}>
        <Col span={24}>
          <Text strong>Address:</Text>
          <Text>
            {" "}
            Jeevan Building, Street 4, Kakaityaa Hills, Hitech city, Hyderabad,
            Telengana - 500044
          </Text>
        </Col>
      </Row>
    </div>
  );
};

const Review = ({ next }) => {
  const [checked1, setChecked1] = useState(true);
  const [checked2, setChecked2] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isOtpModalVisible, setIsOtpModalVisible] = useState(false);
  const [isAgreed, setIsAgreed] = useState(false);

  const showOtpModal = () => {
    setIsOtpModalVisible(true);
  };
  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setIsOtpModalVisible(false);
  };

  const onAgreeChange = (e) => {
    setIsAgreed(e.target.checked);
  };

  const onCheckboxChange1 = (e) => {
    setChecked1(e.target.checked);
  };

  const onCheckboxChange2 = (e) => {
    setChecked2(e.target.checked);
  };
  return (
    <>
      <TermsModal
        handleCancel={handleCancel}
        isModalVisible={isModalVisible}
        isAgreed={isAgreed}
        onAgreeChange={onAgreeChange}
        onDone={() => {
          showOtpModal();
          setIsModalVisible(false);
        }}
      />
      <DepositOtp
        handleCancel={handleCancel}
        isModalVisible={isOtpModalVisible}
        handleConfirm={() => {
          next();
        }}
      />
      <div className="additional-info w60 review">
        <div className="p1 review-head">
          <h3>Review your information</h3>
          <p className="dim">
            Take a moment to review your details below before proceeding
            further.
          </p>
        </div>
        <DepositSummary />
        <br />
        <PersonalInformation />
        <br />
        <NomineeDetails />
        <br />

        <div className="pl1">
          <Row gutter={16} style={{ marginTop: 20 }}>
            <Checkbox checked={checked1} onChange={onCheckboxChange1}>
              Kindly check the above details carefully before initiating the
              payment.
            </Checkbox>
          </Row>
          <Row gutter={16} style={{ marginTop: 10 }}>
            <Checkbox checked={checked2} onChange={onCheckboxChange2}>
              I acknowledge that I have read and agreed the Terms & Conditions
              as well as the Refund & Cancellation policy.
            </Checkbox>
          </Row>
          <div className="action-btns">
            <button className="back-btn">Cancel</button>
            <button
              className="send-btn"
              disabled={!checked2}
              onClick={showModal}
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Review;
